:host {
  border: var(--size-px) solid var(--pos-border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--size-8);
  max-width: var(--size-96);
  background: var(--pos-card-background);
}

.links {
  display: flex;
  flex-direction: column;
  gap: var(--size-3);
  max-width: 80vw;
}
